import { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MusicPlayer from "@/components/MusicPlayer";
import Home from "@/pages/Home";
import Coaching from "@/pages/Coaching";
import Escrow from "@/pages/Escrow";
import Resources from "@/pages/Resources";
import Lifestyles from "@/pages/Lifestyles";
import Community from "@/pages/Community";
import DealRoom from "@/pages/DealRoom";
import HomeValue from "@/pages/HomeValue";
import JoinTeam from "@/pages/JoinTeam";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import ClientLibrary from "@/pages/ClientLibrary";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import InsiderResources from "@/pages/InsiderResources";
import Celebrations from "@/pages/Celebrations";
import CelebrationsAdmin from "@/pages/CelebrationsAdmin";
import AdminPage from "@/pages/AdminPage";
import JournalArticle from "@/pages/JournalArticle";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/escrow" element={<Escrow />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/journal/:slug" element={<JournalArticle />} />
            <Route path="/insider-resources" element={<InsiderResources />} />
            <Route path="/lifestyles" element={<Lifestyles />} />
            <Route path="/community" element={<Community />} />
            <Route path="/celebrations" element={<Celebrations />} />
            <Route path="/celebrations/admin" element={<CelebrationsAdmin />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/deal-room" element={<DealRoom />} />
            <Route path="/home-value" element={<HomeValue />} />
            <Route path="/join-team" element={<JoinTeam />} />
            <Route path="/store" element={<Store />} />
            <Route path="/store/:id" element={<ProductDetail />} />
            <Route path="/client-library" element={<ClientLibrary />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <MusicPlayer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
